module.exports = __webpack_public_path__ + "static/media/interpreting.f299f8ad.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/interpreting.svg
// module id = 453
// module chunks = 0